module.exports = __webpack_public_path__ + "img/favoritesFolder.86d1a52a.png";